import React, { PureComponent } from 'react'

import './Map.css'

const DEFAULT_ZINDEX = 100

const createIcon = (google, fillColor = '#a5bcc7') => ({
  path: `M23.809 14.815a8.812 8.812 0 0 0-8.807-8.809 8.812 8.812 0 0 0-8.81 8.808 8.812 8.812 0 0 0 8.81 8.812 8.812 8.812 0 0 0 8.807-8.81m5.873 0a14.594 14.594 0 0 1-1.595 6.665L15.002 47.115S1.806 21.267 1.757 21.158a14.583 14.583 0 0 1-1.44-6.341C.317 6.705 6.891.133 15.002.133c8.109-.001 14.682 6.573 14.68 14.682z`,
  strokeWeight: 1,
  strokeColor: '#ffffff',
  fillOpacity: 1,
  fillColor,
  anchor: new google.maps.Point(15, 48)
})

const mapOptions = google => ({
  mapTypeId: google.maps.MapTypeId.TERRAIN,
  panControl: false,
  mapTypeControl: false,
  gestureHandling: 'cooperative',
  streetViewControl: false,
  maxZoom: 17,
  styles: [
    { stylers: [{ hue: '#44ccff' }, { saturation: -75 }, { lightness: 20 }] }
  ]
})

export default class Map extends PureComponent {
  selectMarker = (marker, location, icon, selectedIcon) => {
    if (this.selectedMarker !== undefined) {
      this.selectedMarker.setIcon(icon)
      this.selectedMarker.setZIndex(DEFAULT_ZINDEX)
    }
    marker.setIcon(selectedIcon)
    marker.setZIndex(101)
    this.map.panTo(location)
    this.selectedMarker = marker
  }

  btnTouched = (marker, location, icon, selectedIcon) => e => {
    this.selectMarker(marker, location, icon, selectedIcon)
  }

  markerTouched = (marker, location, code, icon, selectedIcon) => e => {
    const { onChanged } = this.props
    onChanged(code)
    this.selectMarker(marker, location, icon, selectedIcon)
  }

  initMarker = (google, location, code, icon, selectedIcon) => {
    const marker = new google.maps.Marker({
      position: location,
      map: this.map,
      icon: icon,
      zIndex: DEFAULT_ZINDEX
    })

    document
      .getElementById(`btn-meeting-${code}`)
      .addEventListener(
        'click',
        this.btnTouched(marker, location, icon, selectedIcon)
      )

    marker.addListener(
      'click',
      this.markerTouched(marker, location, code, icon, selectedIcon)
    )
  }

  initMap = () => {
    const { markers } = this.props

    const google = window.google
    const bounds = new google.maps.LatLngBounds()
    this.map = new google.maps.Map(
      document.getElementById('map'),
      mapOptions(google)
    )

    const icon = createIcon(google)
    const selectedIcon = createIcon(google, '#c1142b')

    markers.forEach(m => {
      this.initMarker(google, m.location, m.code, icon, selectedIcon)
      bounds.extend(new google.maps.LatLng(m.location.lat, m.location.lng))
    })

    this.map.fitBounds(bounds)
    this.map.panToBounds(bounds)
  }

  componentDidMount() {
    this.initMap()
  }

  componentWillUpdate() {
    const { selectedMarker, markers } = this.props

    if (selectedMarker !== undefined && markers.length === 1) {
      const google = window.google

      markers.filter(m => m.code === selectedMarker).forEach(marker => {
        new google.maps.Marker({
          position: marker.location,
          map: this.map,
          icon: createIcon(google, '#c1142b'),
          zIndex: DEFAULT_ZINDEX
        })
      })
    }
  }

  render() {
    return <div className="cm-map" id="map" />
  }
}



// WEBPACK FOOTER //
// ./src/Map.js